import { ICellRendererParams } from 'ag-grid-enterprise';

export function formatAccountNumber(value?: string | null): string {
  if (!value) return '';
  if (value === 'N/A') return 'N/A';
  return value.length >= 4 ? `*${value.slice(-4)}` : `*${'0'.repeat(4 - value.length)}${value}`;
}

const accountCellRenderer = ({ value }: ICellRendererParams) => (
  <span dir="ltr" style={{ display: 'block', width: '100%', textAlign: 'right' }}>
    {formatAccountNumber(value as string | null)}
  </span>
);

export default accountCellRenderer;
